// detail.js
document.addEventListener('DOMContentLoaded', () => {
  const accordionSets = document.querySelectorAll('.accordion-container .set');

  accordionSets.forEach(set => {
    const header = set.querySelector('a');
    if (!header) return;

    // 토글 아이콘 (+) 추가 (이미 있다면 재사용)
    let toggleIcon = header.querySelector('.toggle-icon');
    if (!toggleIcon) {
      toggleIcon = document.createElement('span');
      toggleIcon.classList.add('toggle-icon');
      toggleIcon.style.marginLeft = '10px';
      header.appendChild(toggleIcon);
    }

    const content = set.querySelector('.content');
    if (!content) return;

    const title = header.textContent.replace(/\s+/g, ' ').trim();
    const isDescription = (title === 'Description');

    // ✅ 초기 상태: Description만 열기
    set.classList.toggle('active', isDescription);
    content.style.display = isDescription ? 'block' : 'none';
    toggleIcon.textContent = isDescription ? '-' : '+';

    header.addEventListener('click', function(e) {
      e.preventDefault();

      if (set.classList.contains('active')) {
        set.classList.remove('active');
        content.style.display = 'none';
        toggleIcon.textContent = '+';
      } else {
        accordionSets.forEach(otherSet => {
          if (otherSet !== set) {
            otherSet.classList.remove('active');
            const otherContent = otherSet.querySelector('.content');
            if (otherContent) otherContent.style.display = 'none';
            const otherHeader = otherSet.querySelector('a');
            const otherToggle = otherHeader?.querySelector('.toggle-icon');
            if (otherToggle) otherToggle.textContent = '+';
          }
        });

        set.classList.add('active');
        content.style.display = 'block';
        toggleIcon.textContent = '-';
      }
    });
  });
});